export const MESSAGES_POLLING_INTERVAL = 5000;
export const MESSAGES_WORKER_EVENT_TYPES = {
    LOAD_THREADS: 'messages/load_threads',
    THREADS_LOADED: 'messages/threads_loaded'
};
export var THREAD_STATES;
(function (THREAD_STATES) {
    THREAD_STATES["SENDING"] = "Sending...";
    THREAD_STATES["DELIVERED"] = "Delivered";
    THREAD_STATES["READ"] = "Read";
    THREAD_STATES["FAILED"] = "Failed";
})(THREAD_STATES || (THREAD_STATES = {}));
export var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE[MESSAGE_TYPE["NORMAL"] = 0] = "NORMAL";
    MESSAGE_TYPE[MESSAGE_TYPE["ERROR"] = 1] = "ERROR";
    MESSAGE_TYPE[MESSAGE_TYPE["SYSTEM"] = 2] = "SYSTEM";
})(MESSAGE_TYPE || (MESSAGE_TYPE = {}));
export const ALLOWED_ATTACHMENT_TYPES = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
